import * as tslib_1 from "tslib";
import { OnInit, ElementRef, Renderer2 } from '@angular/core';
// @ts-ignore
import ApexCharts from 'apexcharts';
import { MatPaginator, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material';
import { EmsalerttabledialogComponent } from '../emsalerttabledialog/emsalerttabledialog.component';
import { EmspopuptableComponent } from './emspopuptable/emspopuptable.component';
var EmsComponent = /** @class */ (function () {
    function EmsComponent(matDialog, dialog, ngxLoader, datePipe, renderer, EmsdashboardService, deviceManagerSer, transMngSer) {
        this.matDialog = matDialog;
        this.dialog = dialog;
        this.ngxLoader = ngxLoader;
        this.datePipe = datePipe;
        this.renderer = renderer;
        this.EmsdashboardService = EmsdashboardService;
        this.deviceManagerSer = deviceManagerSer;
        this.transMngSer = transMngSer;
        this.qwerty = 9;
        this.myData = [];
        this.energymeterIdsArray = [];
        this.AllEnergyMeterMonthData = [];
        this.harmonics = 0;
        this.voltageHigh = 0;
        this.voltageLow = 0;
        this.overload = 0;
        this.lowPowerFactor = 0;
        this.avgpfd = 0.0;
        this.speakerOn = true;
        this.muteSuggestions = false;
        this.showLoader = true;
        this.isMain = true;
        this.bgToggle = true;
        this.logavgpf = 0;
        this.labelStyles = {
            position: 'Inside',
            format: '{value}',
            offset: 4,
            color: 'red',
            width: 2
        };
        this.kwhData = 1953790.85;
        this.color = "green";
        this.energyMeterId = [];
        this.blinkState = 'visible';
        this.rangeStart1 = -1;
        this.rangeEnd1 = 1;
        this.lengtho = 0;
        this.energyMeterSum = {};
        this.showInfo = 'first';
        this.meterIdAveragePfArray = [];
        this.animationRunning = true;
        this.animationRunnings = true;
        this.totalkwhcurrentmonth = 0;
        this.totalKvah = 0;
        this.currentUserData = JSON.parse(localStorage.getItem('userData'));
        this.LiveAlertsArray = [];
        this.allmetersid = {};
        this.searchname = '';
        this.totalMeters = 0;
        this.onlineMeters = 0;
        this.offlineMeters = 0;
        this.normalMeters = 0;
        this.alertMeters = 0;
        this.allmeterstatusdata = {};
        this.searchQuery = '';
    }
    EmsComponent.prototype.toggleSpeaker = function () {
        this.speakerOn = !this.speakerOn;
        this.muteSuggestions = !this.speakerOn;
    };
    EmsComponent.prototype.ngAfterViewInit = function () {
        this.monthDiv = this.monthWiseConsumption;
        this.energyconsumption = this.energyconsumption_graph;
        this.dayDiv = this.daywiseConsumption;
        this.minuteDiv = this.minutewiseConsumption;
    };
    EmsComponent.prototype.ngOnInit = function () {
        this.ngxLoader.startLoader('emsDashboard');
        this.getEnergymetrId();
        /*  ** OLD Code **
        this.blink(this.alertCountGraph);
        this.ngxLoader.startLoader('emsDashboard');
          */
    };
    //***********************************CODES *******************************//
    EmsComponent.prototype.getEnergymetrId = function () {
        var _this = this;
        var user_id = this.currentUserData.userid;
        var roleid = this.currentUserData.roleid;
        this.EmsdashboardService.getEnergyMeterIds({ "userid": user_id, "roleid": roleid }).subscribe(function (response) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var _a, mainMeters;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.meteridDesc = response;
                        _a = this;
                        return [4 /*yield*/, response.data.map(function (meter) { return meter.meterSerialNumber; })];
                    case 1:
                        _a.allmetersid = _b.sent();
                        mainMeters = response.data.filter(function (meter) { return meter.meterType === "Main"; });
                        // If no main meter found, use allmetersid instead
                        this.mainmeter = mainMeters.length > 0
                            ? mainMeters.map(function (meter) { return meter.meterSerialNumber; })
                            : this.allmetersid;
                        if (mainMeters.length == 0) {
                            this.isMain = false;
                            this.searchname = "Search by Meter ID";
                        }
                        else {
                            this.searchname = "Search by Main Meter ID";
                        }
                        // this.dayWiseConsumptionGraph(this.mainmeter);
                        // this.MonthwiseAveragekwh(this.mainmeter); // check (only main meter kwh)
                        this.getmonthdatameterwise(this.allmetersid);
                        this.checkStatusOfMters(this.allmetersid); // all Meter status
                        //this.getAllEnergyMeterMonthData(this.allmetersid);    // for Energy Consumption
                        this.MonthwiseAveragepf(this.mainmeter); // for avgpf
                        this.hourlyWiseConsumptionGraph(this.mainmeter); // Hourly kwh
                        this.getAlertsData(); // live alert
                        this.alertSection(this.allmetersid); // Parameter alert
                        return [2 /*return*/];
                }
            });
        }); });
    };
    EmsComponent.prototype.getmonthdatameterwise = function (meters) {
        var _this = this;
        this.EmsdashboardService.getemsmonthdata({ "meterid": meters }).subscribe(function (response) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var responseData, meterDescData, combinedResults, totalMonthKwh, totalMonthKvah, testdata, totalLogKwh, mainMeterMonthKwh, mainMeterMonthKvah, totalKwh, totalKvah, totalavgpf, foundMainMeter, _a, _b, meter;
            var e_1, _c;
            return tslib_1.__generator(this, function (_d) {
                responseData = response && response.data ? response.data : [];
                meterDescData = this.meteridDesc && this.meteridDesc.data ? this.meteridDesc.data : [];
                combinedResults = responseData.map(function (item) {
                    var pfavg = item.count != 0 ? (Number(item.avgpf) / item.count).toFixed(2) : 0;
                    var matchingDesc = meterDescData.find(function (desc) { return desc.meterSerialNumber === item.meterid; });
                    return tslib_1.__assign({}, item, { description: matchingDesc ? matchingDesc.assetName : "No description found for meterid: " + item.meterid, type: matchingDesc ? matchingDesc.meterType : "No meter type found for meterid: " + item.meterid, pfavg: pfavg });
                });
                this.alldataofmonth = combinedResults;
                this.alldataofmonth.sort(function (a, b) {
                    var idA = a.meterid;
                    var idB = b.meterid;
                    if (idA < idB)
                        return -1;
                    if (idA > idB)
                        return 1;
                    return 0;
                });
                totalMonthKwh = 0;
                totalMonthKvah = 0;
                testdata = 0;
                totalLogKwh = 0;
                mainMeterMonthKwh = 0;
                mainMeterMonthKvah = 0;
                totalKwh = 0;
                totalKvah = 0;
                totalavgpf = 0;
                foundMainMeter = false;
                try {
                    for (_a = tslib_1.__values(this.alldataofmonth), _b = _a.next(); !_b.done; _b = _a.next()) {
                        meter = _b.value;
                        if (meter.type == "Main") {
                            totalKwh = Number(meter.logsystemkwh);
                            totalKvah = Number(meter.logsystemkvah);
                            mainMeterMonthKwh += Number(meter.kwh);
                            mainMeterMonthKvah += Number(meter.kvah);
                            totalavgpf = Number(meter.logavgpf);
                            foundMainMeter = true;
                        }
                        else {
                            totalMonthKwh += Number(meter.kwh);
                            totalMonthKvah += Number(meter.kvah);
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                console.log("Number(meter.kwh).toFixed(2)", totalMonthKwh);
                if (!foundMainMeter) {
                    totalKwh = 0;
                    totalKvah = 0;
                    totalavgpf = "NO DATA";
                }
                this.latestkwh_p = totalKwh;
                this.totalKvah = totalKvah;
                this.logavgpf = totalavgpf;
                this.energyBalanceGraph(Number(mainMeterMonthKwh).toFixed(2), Number(totalMonthKwh.toFixed(2)), Number(mainMeterMonthKvah).toFixed(2), Number(totalMonthKvah).toFixed(2));
                return [2 /*return*/];
            });
        }); });
    };
    EmsComponent.prototype.filterData = function () {
        if (!this.searchQuery) {
            return this.alldataofmonth;
        }
        var query = this.searchQuery.toLowerCase();
        return this.alldataofmonth.filter(function (subMeter) {
            return subMeter.meterid.toLowerCase().includes(query) ||
                subMeter.description.toLowerCase().includes(query);
        });
    };
    EmsComponent.prototype.checkStatusOfMters = function (meters) {
        var _this = this;
        this.EmsdashboardService.meterStatus({ "meterid": meters }).subscribe(function (response) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var meterData;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                meterData = Array.isArray(response.data) ? response.data : response;
                this.allmeterstatusdata = meterData;
                this.totalMeters = meterData.length;
                this.onlineMeters = 0;
                this.offlineMeters = 0;
                this.normalMeters = 0;
                this.alertMeters = 0;
                meterData.forEach(function (meter) {
                    var status = meter.status, alertStatus = meter.alertStatus;
                    if (status === "Online") {
                        _this.onlineMeters++;
                        if (alertStatus === "No Alert") {
                            _this.normalMeters++;
                        }
                    }
                    else if (status === "Offline") {
                        _this.offlineMeters++;
                    }
                    if (alertStatus === "Alert Generated") {
                        _this.alertMeters++;
                    }
                });
                return [2 /*return*/];
            });
        }); });
    };
    EmsComponent.prototype.hourlyWiseConsumptionGraph = function (meterArray) {
        var _this = this;
        var YesterdaysData = [];
        var data = [];
        var time = [];
        var today = new Date();
        var date = new Date(today.getFullYear(), today.getMonth(), 1);
        var days = [];
        this.EmsdashboardService.getCurrentAndPreviousDaysKwhData({ "meterArray": meterArray }).subscribe(function (response) {
            if (response.result[0].length > 0 || response.result[1].length > 0) {
                response.result[0].forEach(function (row) {
                    data.push(parseFloat(Number(row.kwhdata).toFixed(2)));
                    time.push(row.hour);
                });
                response.result[1].forEach(function (data) {
                    YesterdaysData.push(parseFloat(Number(data.kwhdata).toFixed(2)));
                });
            }
            else {
                data.push(0);
                YesterdaysData.push(0);
            }
            while (date.getMonth() === today.getMonth()) {
                days.push(new Date(date).getUTCDate());
                date.setDate(date.getDate() + 1);
            }
            var options = {
                colors: ['#0B84A5', '#F6C85F'],
                series: [
                    { name: "Yesterday", data: YesterdaysData },
                    { name: "Today", data: data }
                ],
                chart: {
                    height: '100%',
                    width: '100%',
                    type: 'area',
                    toolbar: {
                        show: true,
                        tools: { download: true, selection: true, zoom: false },
                        style: {
                            fontFamily: 'Arial, sans-serif',
                            fontSize: '1.5vh',
                            fontWeight: 'bold',
                            color: '#000000',
                            background: 'transparent',
                        },
                    },
                },
                title: {
                    text: "Hourly KWH",
                    align: 'center',
                    style: {
                        fontSize: '2vh',
                        align: 'center',
                        fontWeight: 'bold',
                        color: '#ffffff'
                    },
                    margin: 20,
                },
                grid: { show: false },
                legend: { position: 'top', labels: { useSeriesColors: true } },
                dataLabels: { enabled: false },
                stroke: { curve: 'smooth' },
                yaxis: {
                    title: {
                        text: "KWH",
                        style: { fontSize: '1.5vh', color: "white", fontWeight: 'bold' },
                    },
                    labels: { style: { fontSize: '1.5vh', colors: '#FFFFFF', fontWeight: 'bold' } }
                },
                xaxis: {
                    type: 'category',
                    categories: time,
                    labels: {
                        style: { fontSize: '1.5vh', colors: '#FFFFFF', fontWeight: 'bold', background: 'white', },
                    },
                },
                tooltip: {
                    shared: true,
                    intersect: false,
                    theme: 'dark',
                    style: {
                        backgroundColor: '#333',
                    },
                },
            };
            var chart = new ApexCharts(_this.minuteDiv.nativeElement, options);
            chart.render();
            _this.ngxLoader.stopLoader('emsDashboard');
        });
    };
    EmsComponent.prototype.alertSection = function (meters) {
        var _this = this;
        this.EmsdashboardService.alertSections({ meterid: meters }).subscribe(function (response) {
            if (response.code === 1 && response.data.length > 0) {
                _this.allAlertSectiondata = response.data;
                response.data.forEach(function (alert) {
                    switch (alert.parametername) {
                        case 'apLowPowerfactor':
                            _this.lowPowerFactor++;
                            break;
                        case 'communicationFailure':
                            _this.communicationFailure++;
                            break;
                        case 'overloadAlert':
                            _this.overload++;
                            break;
                        case 'lowVoltage':
                            _this.voltageLow++;
                            break;
                        case 'highVoltage':
                            _this.voltageHigh++;
                            break;
                        case 'harmonics':
                            _this.harmonics++;
                            break;
                    }
                });
            }
        });
    };
    EmsComponent.prototype.popupTablealert = function (state, selected) {
        console.log("asdsadasd", selected);
        if (selected > 0) {
            var dialogConfig = new MatDialogConfig();
            dialogConfig.disableClose = true;
            dialogConfig.autoFocus = true;
            dialogConfig.height = '80%';
            dialogConfig.width = '70%';
            if (this.totalMeters !== undefined) {
                dialogConfig.data = {
                    type: state,
                    alldata: this.allAlertSectiondata,
                    show: false
                };
                if (selected == "alertDataSelected") {
                    dialogConfig.data['selected'] = selected;
                }
                if (selected == "helathCenterDataSelected") {
                    dialogConfig.data['selected'] = selected;
                }
                var dialogRef = this.matDialog.open(EmspopuptableComponent, dialogConfig);
                dialogRef.afterClosed().subscribe(function (response) {
                });
            }
        }
    };
    EmsComponent.prototype.MonthwiseAveragepf = function (meterArray) {
        var _this = this;
        var user_id = this.currentUserData.userid;
        this.EmsdashboardService.getMonthwiseAveragePF({ "meterArray": meterArray }).subscribe(function (response) {
            var data = response.result;
            if (data.length > 0) {
                _this.avgpfd = data[response.result.length - 1].avgpf.toFixed(2);
                _this.SuggestionsTileData();
                var avgPfValues = data.map(function (item) { return item.avgpf; });
                var months = data.map(function (item) { return item.month; });
                var options = {
                    series: [
                        {
                            name: "Average PF",
                            data: avgPfValues
                        },
                    ],
                    chart: {
                        type: "bar",
                        color: "white",
                        height: '100%',
                        animations: {
                            speed: 500
                        }
                    },
                    title: {
                        text: "Monthwise Average PF",
                        align: 'center',
                        style: {
                            fontSize: '2vh',
                            fontWeight: 'bold',
                            color: '#ffffff'
                        },
                        margin: 20,
                    },
                    plotOptions: {
                        bar: {
                            horizontal: false,
                            columnWidth: "40%"
                        }
                    },
                    dataLabels: {
                        enabled: false,
                        dropShadow: {
                            blur: 3,
                            opacity: 0.8
                        }
                    },
                    stroke: {
                        curve: "straight",
                        width: 2
                    },
                    legend: {
                        show: true,
                        inverseOrder: true,
                        labels: {
                            useSeriesColors: true
                        },
                        markers: {
                            hover: {
                                sizeOffset: 5
                            }
                        }
                    },
                    colors: ['#ff8c00'],
                    yaxis: {
                        title: {
                            text: "PF",
                            style: {
                                fontSize: '1.5vh',
                                color: '#FFFFFF',
                                fontWeight: 'bold'
                            }
                        },
                        labels: {
                            style: {
                                fontSize: '1.5vh',
                                colors: '#FFFFFF',
                                fontWeight: 'bold',
                            },
                            formatter: function (value) {
                                return value.toFixed(2);
                            }
                        }
                    },
                    xaxis: {
                        categories: months.map(function (month) {
                            var monthNames = [
                                "Jan", "Feb", "Mar", "Apr", "May", "Jun",
                                "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
                            ];
                            return monthNames[month - 1];
                        }),
                        labels: {
                            style: {
                                padding: "1%",
                                fontSize: '1.5vh',
                                colors: '#FFFFFF',
                                fontWeight: 'bold'
                            }
                        }
                    },
                    grid: {
                        show: false
                    },
                    markers: {
                        hover: {
                            sizeOffset: 5
                        }
                    }
                };
                var chart = new ApexCharts(_this.consumption_graph_mb.nativeElement, options);
                chart.render();
                _this.ngxLoader.stopLoader('emsDashboard');
            }
            else {
                _this.ngxLoader.stopLoader('emsDashboard');
            }
        });
    };
    EmsComponent.prototype.energyBalanceGraph = function (Mainkwh, subKwh, mainKvah, subKvah) {
        var options = {
            series: [
                {
                    name: 'Main Meter',
                    data: [Mainkwh, mainKvah]
                },
                {
                    name: 'Sub Meters',
                    data: [subKwh, subKvah]
                }
            ],
            chart: {
                type: 'bar',
                height: "100%"
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                }
            },
            legend: { position: 'top', labels: { useSeriesColors: true } },
            dataLabels: {
                enabled: true,
                offsetY: -20,
                style: {
                    fontSize: '1.5vh',
                    colors: ['#fff']
                }
            },
            stroke: {
                show: true,
                width: 1,
                colors: ['#fff']
            },
            tooltip: {
                shared: true,
                intersect: false,
                y: {
                    formatter: function (val, opts) {
                        return "" + val;
                    }
                }
            },
            xaxis: {
                categories: ["Kwh", "Kvah"],
                labels: {
                    style: {
                        fontSize: '1.5vh',
                        colors: '#FFFFFF',
                        fontWeight: 'bold',
                    },
                }
            },
            yaxis: {
                title: {
                    text: "consumption",
                    style: {
                        fontSize: '1.5vh',
                        color: '#FFFFFF',
                    }
                },
                labels: {
                    style: {
                        fontSize: '1.5vh',
                        colors: '#FFFFFF',
                        fontWeight: 'bold',
                    },
                }
            },
            grid: {
                show: false
            }
        };
        var chart = new ApexCharts(document.querySelector("#energyBalance"), options);
        chart.render();
    };
    EmsComponent.prototype.alertCountGraph = function () {
        var options = {
            series: [44, 55, 41, 17, 15],
            chart: {
                height: "100%",
                type: 'donut',
            },
            plotOptions: {
                pie: {
                    startAngle: -90,
                    endAngle: 270
                }
            },
            dataLabels: {
                enabled: false
            },
            fill: {
                type: 'gradient',
            },
            legend: {
                formatter: function (val, opts) {
                    return val + " - " + opts.w.globals.series[opts.seriesIndex];
                }
            },
            title: {
                text: 'Device Conncetion Status'
            },
            responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }
                }]
        };
        var chart = new ApexCharts(document.querySelector("#alertsGraph"), options);
        chart.render();
    };
    EmsComponent.prototype.popupTable = function (state, selected) {
        var dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.height = '80%';
        dialogConfig.width = '70%';
        if (this.totalMeters !== undefined) {
            dialogConfig.data = {
                type: state,
                allstatus: this.allmeterstatusdata,
                show: true
            };
            if (selected == "alertDataSelected") {
                dialogConfig.data['selected'] = selected;
            }
            if (selected == "helathCenterDataSelected") {
                dialogConfig.data['selected'] = selected;
            }
            var dialogRef = this.matDialog.open(EmspopuptableComponent, dialogConfig);
            dialogRef.afterClosed().subscribe(function (response) {
            });
        }
    };
    EmsComponent.prototype.getAlertsData = function () {
        var _this = this;
        var user_id = this.currentUserData.userid;
        this.EmsdashboardService.getLastUpdatedAlert({ "userid": user_id }).subscribe(function (response) {
            if (response.result.length > 0) {
                console.log("alertdata", response.result);
                _this.LiveAlertsArray = response.result;
            }
        });
    };
    EmsComponent.prototype.SuggestionsTileData = function () {
        if (this.avgpfd < 0.9) {
            return "Low Lagging Power Factor (PF < 0.9)";
        }
        else if (this.avgpfd >= 1) {
            return "High Leading Power Factor (PF > 1 or close to 1)";
        }
        else {
            return "Power Factor is within an acceptable range.";
        }
    };
    EmsComponent.prototype.getPowerFactorSuggestion = function () {
        var e_2, _a;
        var lowMeterIds = [];
        var highMeterIds = [];
        try {
            for (var _b = tslib_1.__values(this.AllEnergyMeterMonthData), _c = _b.next(); !_c.done; _c = _b.next()) {
                var meterData = _c.value;
                if (meterData.avgpf < 0.9) {
                    lowMeterIds.push(meterData.energyMeterId + '(' + meterData.assetName + ')');
                }
                else if (meterData.averagePf > 1) {
                    highMeterIds.push(meterData.energyMeterId + '(' + meterData.assetName + ')');
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
        var suggestions = [];
        if (lowMeterIds.length > 0) {
            var meterListLow = lowMeterIds.join(', ');
            suggestions.push("Energy meters " + meterListLow + " have low average power factor.\n  Consider improving power factor for better efficiency.");
        }
        if (highMeterIds.length > 0) {
            var meterListHigh = highMeterIds.join(', ');
            suggestions.push("Energy meters " + meterListHigh + " have high average power factor.\n  Investigate and analyze any capacitive loads or equipment connected to the system that might be contributing to the leading power factor.");
        }
        if (suggestions.length > 0) {
            return suggestions.join('\n\n');
        }
        else {
            return "Power Factor is within an acceptable range.";
        }
    };
    EmsComponent.prototype.openTodayAlertsModal = function () {
        var dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.height = '90%';
        dialogConfig.width = '90%';
        dialogConfig.data = {
            type: "AlertsTable",
            currentUserData: this.currentUserData,
        };
        this.dialogRefas = this.dialog.open(EmsalerttabledialogComponent, dialogConfig);
    };
    EmsComponent.prototype.blink = function () {
        var _this = this;
        this.blinkState = 'hidden';
        setTimeout(function () {
            _this.blinkState = 'visible';
            _this.blink();
        }, 500);
    };
    EmsComponent.prototype.stopAnimations = function () {
        this.animationRunnings = false;
        var alertsLists = document.getElementById('suggestion-list');
        if (alertsLists) {
            alertsLists.classList.remove('suggestionlists');
        }
    };
    EmsComponent.prototype.startAnimations = function () {
        this.animationRunnings = true;
        var alertsLists = document.getElementById('suggestion-list');
        if (alertsLists) {
            alertsLists.classList.add('suggestionlists');
        }
    };
    EmsComponent.prototype.toggleBackground = function () {
        var div = document.getElementById('change');
        var icon = document.getElementById('icon');
        if (this.bgToggle) {
            div.style.backgroundColor = "white";
            icon.className = "fas fa-sun";
            icon.style.color = "orange";
            this.bgToggle = false;
        }
        else {
            div.style.backgroundColor = "black";
            icon.className = "fas fa-moon";
            icon.style.color = "yellow";
            this.bgToggle = true;
        }
    };
    // **************************OLD CODE *********************************************** //
    EmsComponent.prototype.MonthwiseAveragekwh = function (meterArray) {
        var _this = this;
        var user_id = this.currentUserData.userid;
        console.log("meterArray", meterArray);
        console.log("main meterArray", this.mainmeter);
        this.EmsdashboardService.getMonthwiseConsumptionData({ "meterArray": meterArray }).subscribe(function (response) {
            var data = response.result;
            console.log("response.result", response);
            console.log("data", data);
            var categories = [];
            var consumptionData = [];
            data.forEach(function (row) {
                categories.push(row.month);
                consumptionData.push(Number(row.total_kwh).toFixed(2));
            });
            var prvve = ["0", "0"];
            var months = {
                1: "Jan",
                2: "Feb",
                3: "Mar",
                4: "Apr",
                5: "May",
                6: "Jun",
                7: "Jul",
                8: "Aug",
                9: "Sept",
                10: "Oct",
                11: "Nov",
                12: "Dec"
            };
            var monthLabels = categories.map(function (month) {
                return months[month];
            });
            var options = {
                tooltip: {
                    theme: 'dark',
                    style: {
                        backgroundColor: '#333',
                        color: '#fff'
                    }
                },
                chart: {
                    height: '100%',
                    width: '100%',
                    type: "bar",
                    toolbar: {
                        show: true
                    }
                },
                grid: {
                    show: false,
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: '55%',
                        endingShape: 'rounded'
                    }
                },
                legend: {
                    position: 'top',
                    labels: {
                        useSeriesColors: true
                    },
                },
                title: {
                    text: "Monthly KWH",
                    style: {
                        color: "black"
                    }
                },
                dataLabels: {
                    enabled: false,
                },
                stroke: {
                    width: 1,
                    colors: ["black"]
                },
                series: [
                    {
                        name: "Current Year",
                        data: consumptionData,
                    },
                    {
                        name: "Previous Year",
                        data: prvve,
                    }
                ],
                colors: ['#0B84A5', '#F6C85F'],
                yaxis: {
                    show: true,
                    title: {
                        text: "KWH",
                        rotate: -90,
                        offsetX: 0,
                        offsetY: 0,
                        style: {
                            fontSize: '12px',
                            color: "black",
                            fontWeight: 'bold',
                        }
                    },
                    labels: {
                        style: {
                            fontSize: '12px',
                            color: "black",
                            fontWeight: 'bold',
                        }
                    },
                },
                xaxis: {
                    show: true,
                    categories: monthLabels,
                    labels: {
                        style: {
                            fontSize: '12px',
                            color: "black",
                            fontWeight: 'bold',
                        }
                    },
                    tickPlacement: 'between',
                },
                responsive: [{
                        breakpoint: 768,
                        options: {
                            plotOptions: {
                                bar: {
                                    horizontal: false,
                                    columnWidth: '100%',
                                    endingShape: 'rounded'
                                }
                            },
                            legend: {
                                position: 'bottom',
                            }
                        }
                    }]
            };
            var chart = new ApexCharts(_this.monthDiv.nativeElement, options);
            chart.render();
        });
    };
    EmsComponent.prototype.dayWiseConsumptionGraph = function (meterArray) {
        var _this = this;
        var prvMonthData = [];
        var data = [];
        var day = [];
        var today = new Date();
        var date = new Date(today.getFullYear(), today.getMonth(), 1);
        var days = [];
        var user_id = this.currentUserData.userid;
        this.EmsdashboardService.getCurrentAndPreviousMonthsKwhData({ "meterArray": ['E230005'] }).subscribe(function (response) {
            if (response.result[0].length > 0 || response.result[1].length > 0) {
                response.result[0].forEach(function (row) {
                    data.push(Number(row.kwh).toFixed(2));
                    day.push(row.day);
                });
                response.result[1].forEach(function (data) {
                    prvMonthData.push(Number(data.kwh).toFixed(2));
                });
            }
            else {
                data.push(0);
                prvMonthData.push(0);
            }
            var options = {
                tooltip: {
                    theme: 'dark',
                    style: {
                        backgroundColor: '#333',
                    }
                },
                series: [{
                        name: 'Last Month',
                        data: prvMonthData
                    }, {
                        name: 'Current Month',
                        data: data
                    }],
                chart: {
                    height: '100%',
                    width: '100%',
                    type: 'area',
                    toolbar: {
                        show: true,
                        offsetX: 0,
                        offsetY: 0,
                        tools: {
                            download: true,
                            selection: true,
                            zoom: false,
                            zoomin: false,
                            zoomout: false,
                            pan: false,
                            customIcons: []
                        },
                        export: {
                            csv: {
                                filename: "Consumption",
                                columnDelimiter: ',',
                                headerCategory: 'category',
                                headerValue: 'value',
                                dateFormatter: function (timestamp) {
                                    return new Date(timestamp).toDateString();
                                }
                            },
                            svg: {
                                filename: "Consumption",
                            },
                            png: {
                                filename: "Consumption",
                            }
                        },
                        autoSelected: 'zoom',
                        container: {
                            height: '40px',
                            style: {
                                background: '#000',
                                fill: "black" // Set the background color of the toolbar
                            }
                        },
                        item: {
                            color: '#fff',
                            fontSize: '12px',
                        },
                    },
                },
                grid: {
                    show: false,
                },
                colors: ['#0B84A5', '#F6C85F'],
                legend: {
                    position: 'top',
                    labels: {
                        useSeriesColors: true
                    },
                },
                dataLabels: {
                    enabled: false
                },
                stroke: {
                    curve: 'smooth'
                },
                yaxis: {
                    title: {
                        text: "KWH",
                        rotate: -90,
                        offsetX: 0,
                        offsetY: 0,
                        style: {
                            fontSize: '12px',
                            color: "black",
                            fontWeight: 'bold',
                        }
                    },
                    labels: {
                        style: {
                            fontSize: '12px',
                            color: "black",
                            fontWeight: 'bold',
                        }
                    },
                },
                xaxis: {
                    type: 'number',
                    categories: day,
                    tickAmount: 15,
                    tickPlacement: 'between',
                    labels: {
                        show: true,
                        rotate: 0,
                        style: {
                            fontSize: '12px',
                            color: "black",
                            fontWeight: 'bold'
                        }
                    },
                },
                title: {
                    text: "Daily KWH",
                    style: {
                        color: "black" // Set the label color to white
                    }
                },
            };
            var chart = new ApexCharts(_this.dayDiv.nativeElement, options);
            chart.render();
        });
    };
    EmsComponent.prototype.getAllEnergyMeterMonthData = function (meterArray) {
        var _this = this;
        var user_id = this.currentUserData.userid;
        this.EmsdashboardService.getTotalMonthlyData({ "meterArray": meterArray }).subscribe(function (response) {
            if (response.result[1].length > 0) {
                _this.AllEnergyMeterMonthData = response.result[0];
                _this.AllEnergyMeterMonthData.sort(function (a, b) {
                    var idA = a.energyMeterId;
                    var idB = b.energyMeterId;
                    if (idA < idB)
                        return -1;
                    if (idA > idB)
                        return 1;
                    return 0;
                });
                _this.totalKvah = 0;
                var _loop_1 = function (i) {
                    _this.totalKvah += Number(_this.AllEnergyMeterMonthData[i].monthsystemkvah);
                    var matchedMeter = response.result[1].find(function (meter) { return meter.meterSerialNumber === _this.AllEnergyMeterMonthData[i].energyMeterId; });
                    if (matchedMeter) {
                        _this.AllEnergyMeterMonthData[i].assetName = matchedMeter.assetDescription;
                        _this.AllEnergyMeterMonthData[i].type = matchedMeter.meterType;
                    }
                    else {
                        _this.AllEnergyMeterMonthData[i].assetName = "Unknown Asset"; // Adjust as necessary
                    }
                };
                for (var i = 0; i < _this.AllEnergyMeterMonthData.length; i++) {
                    _loop_1(i);
                }
                _this.totalKvah = Number(_this.totalKvah).toFixed(2);
            }
        });
    };
    EmsComponent.prototype.fetchLatestEMSAlertData = function () {
        var _this = this;
        this.EmsdashboardService.getLiveEMSAlertsData({ userid: this.currentUserData.userid, roleid: this.currentUserData.roleid }).subscribe(function (response) {
            if (_this.LiveAlertsArray.length > 0) {
                if (_this.LiveAlertsArray[_this.LiveAlertsArray.length - 1].id != response.result.id) {
                    _this.LiveAlertsArray.push(response.result);
                    if (_this.dialogRefas && _this.dialogRefas.componentInstance) {
                        _this.dialogRefas.componentInstance.data.newData = response.result;
                    }
                }
            }
            else {
                _this.LiveAlertsArray.push(response.result);
            }
        });
    };
    return EmsComponent;
}());
export { EmsComponent };
